import 'css-chunksrc/feature/provision/TerminalSelect.module.scss';export default {
  "select": "TerminalSelect_select"
};